import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import { SidebarLink } from "./SidebarLink";
import { RouterWorksheetData } from "../Worksheets/Types/Worksheet.Interface";
import { useEffect, useState, type ReactNode } from "react";

interface SidebarSectionHeadingProps {
  openOnPath: string;
  onToggle?: () => void;
  isOpen: boolean;
  excludeMatch?: string;
  height?: number;
  boarderButtom?: boolean;
  greyBackground?: boolean;
  children: ReactNode;
  items: RouterWorksheetData[];
}

export function SidebarSectionHeading(props: SidebarSectionHeadingProps) {
  const [selected, setSelected] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.indexOf(props.openOnPath) > -1) {
      if (
        props.excludeMatch &&
        location.pathname.indexOf(props.excludeMatch) > -1
      ) {
        setSelected(false);
      } else {
        setSelected(true);
      }
    }
  }, [location.pathname, props.openOnPath, props.excludeMatch]);

  const isExactMatch = location.pathname === props.openOnPath;

  const oneLevelUp = props.openOnPath.split('/').slice(0, -1).join('/');
  const linkTo = selected ? oneLevelUp : props.openOnPath;

  return (
    <>
      <Link
        to={linkTo}
        onClick={(e) => {
          e.preventDefault();
          if (props.onToggle) {
            props.onToggle();
          }
          if (selected) {
            setSelected(false);
          }
        }}
        style={{
          height: (props.height || 44) + 'px',

        }}
        className={`SidebarLink ${selected && isExactMatch ? 'selected' : ''} ${props.boarderButtom ? 'borderBottom' : ''
          } ${props.greyBackground ? 'greyBackground' : ''}`}
      >
        <div className="chit" />
        <div className="flex-1">{props.children}</div>
        {selected ? <FaChevronUp /> : <FaChevronDown />}
      </Link>
      <div aria-expanded={props.isOpen}>
        {props.isOpen && props.items && props.items.map((item) => {
          const to = `${props.openOnPath}/${item.to}`;
          return <SidebarLink height={38} key={to} to={to} indent={2}>{item.label}</SidebarLink>
        })}
      </div>
    </>
  )
}